'use strict';
import {
  gtmLaunchProductDetail,
  gtmListenProductVariants
} from '@jspartials/gtm-utils';
import { mediaQuery, getMediaQuery } from '@jspartials/general-utils';
import { initCarousel } from '@jsproduct/detailsPage/carouselMultimedia';
import { listenProductColorVariants } from '@jsproduct/detailsPage/colorVariants';
import { initBottomPadding } from '@jsproduct/detailsPage/handleBottomPadding';
import {
  listenSizeVariantButtons,
  closeSizeVariants
} from '@jsproduct/detailsPage/sizeVariants';
import { listenAddToCartButton } from '@jsproduct/detailsPage/addToCart';
import { initRecommendations } from '@jsproduct/detailsPage/recommendations';
import Modal from '@jsclasses/modal-class';
import { initHistoryPpd } from '@jsproduct/detailsPage/history';
import { initKlarnaMessaging } from '@jsproduct/detailsPage/klarnaMessaging';
import { initFoursixty } from '@jsproduct/detailsPage/foursixty';
import { initWishlistButtonsListeners } from '@jsproduct/detailsPage/wishlist';
import { listenFastSignUpForm } from '@jsproduct/detailsPage/fastSignUpForm';
import {
  addRightColumnScrollBehaviour,
  removeRightColumnScrollBehaviour,
  initAccordionsBehaviour
} from '@jsproduct/detailsPage/productDetails';
import { startZoom } from '@jsproduct/detailsPage/desktopZoom';
import { initShippingMethodMessages } from '@jsproduct/detailsPage/shippingMethodMessage';
import { initTrustPilot } from '@jsproduct/detailsPage/trustpilot';
import { updateAddToCartButton } from '@jspartials/test-ab-utils';

// Variables
const mediaQueryTablet = getMediaQuery(mediaQuery.tablet);
const eventReloadVtoButtons = new CustomEvent('reloadVtoButtons');

/**
 * Initializes the product detail page scripts
 * @returns {void}
 */
const init = () => {
  if (!mediaQueryTablet.matches) {
    initCarousel();
    removeRightColumnScrollBehaviour();
  } else {
    addRightColumnScrollBehaviour();
  }

  listenSizeVariantButtons();

  listenAddToCartButton();

  initRecommendations();

  initFoursixty();

  initTrustPilot();

  initWishlistButtonsListeners();

  listenFastSignUpForm();

  initAccordionsBehaviour();

  startZoom();

  initShippingMethodMessages();

  // Test AB
  updateAddToCartButton();
};

// Listeners

// Resize
mediaQueryTablet.addEventListener('change', function (mm) {
  if (!mm.matches) {
    initCarousel();
    removeRightColumnScrollBehaviour();
  } else {
    closeSizeVariants();
    addRightColumnScrollBehaviour();
  }
});

// After update content
document.addEventListener('afterUpdateContentOfProductDetailPage', function () {
  init();
  document.dispatchEvent(eventReloadVtoButtons);
});

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const gtmProduct = document.querySelector('.gtm-product');

  if (gtmProduct) {
    gtmLaunchProductDetail(gtmProduct.dataset.pid);
  }

  gtmListenProductVariants();

  Modal.initElements('pdp');

  listenProductColorVariants();

  init();

  initHistoryPpd();

  initKlarnaMessaging();

  initBottomPadding();
});
